var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"select",class:{'words': _vm.words},attrs:{"solo":"","color":"grey","items":_vm.items,"item-value":"id","item-text":"name","label":"Tipo de carga","no-data-text":"No se encontraron cargas"},on:{"input":_vm.emitChange},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c195054","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/CompanyLoadFilter.vue
// module id = null
// module chunks = 